import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { Box, BREAKPOINT, COLOR } from '@npco/zeller-design-system'
import lottie from 'lottie-web/build/player/lottie_light'

import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { LottieAnimationData } from 'types/lottie'

export const IllustrationAnimation = () => {
  const illustrationRef = useRef<HTMLDivElement>(null)
  const [animationFile, setAnimationFile] = useState<LottieAnimationData>()
  const isMobile = useIsMobileResolution()
  const isMobileOrMediumDesktop = useIsMobileResolution(BREAKPOINT.LG)

  const animationFileName = useMemo(() => {
    if (isMobile) {
      return 'custom-screensaver-mobile'
    }
    if (isMobileOrMediumDesktop) {
      return 'custom-screensaver-tablet'
    }
    return 'custom-screensaver-desktop'
  }, [isMobile, isMobileOrMediumDesktop])

  useEffect(() => {
    ;(async () => {
      setAnimationFile(undefined)
      const module = await import(
        `../../../assets/animations/custom-screensaver/${animationFileName}.json`
      )
      setAnimationFile(module.default)
    })()
  }, [animationFileName])

  useLayoutEffect(() => {
    const loadLottieAnimation = () => {
      if (!illustrationRef.current || !animationFile) return undefined

      return lottie.loadAnimation({
        container: illustrationRef.current,
        animationData: animationFile,
        loop: true,
      })
    }

    const animation = loadLottieAnimation()
    return () => animation?.destroy()
  }, [animationFile])

  return <Box backgroundColor={COLOR.GREY_400} ref={illustrationRef} />
}
